import { atom } from 'jotai';

export type AuthStep = 'identifier' | 'verification' | 'signupDetails';
export type AuthMode = 'signin' | 'signup';
export type IdentifierType = 'phone' | 'email';

export const authStepAtom = atom<AuthStep>('identifier');
export const authModeAtom = atom<AuthMode>('signin');
export const authPasswordShowAtom = atom<boolean>(false);
export const authIdentifierAtom = atom<string>(''); // holds phone or email
export const authIdentifierTypeAtom = atom<IdentifierType>('email');
export const authSignInIDAtom = atom<string>('');
export const authRedirectToAtom = atom<string>('');
